import { z } from "zod";

export const getVehiclesSivDataListByCompanyResponse = z.array(
  z.object({
    vin: z.string(),
    brand: z.string(),
    registrationNumber: z.string(),
    model: z.string(),
    dateMec: z.iso.datetime(),
  }),
);

export type GetVehiclesSivDataListByCompanyResponse = z.infer<
  typeof getVehiclesSivDataListByCompanyResponse
>;
